import { featureFlagsService } from '@waitroom/common';
import { FeatureFlag as FeatureFlagType, PostHogFeatureFlag } from '@waitroom/models';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { ReactElement, ReactNode } from 'react';

export interface FeatureFlagGateProps {
  flag: FeatureFlagType;
  children?: ReactNode;
}

export const usePostHogFeatureFlag = (flag: PostHogFeatureFlag) => {
  const override = featureFlagsService.override;
  const phEnabled = useFeatureFlagEnabled(flag);
  return override !== undefined ? override : phEnabled;
};

const FeatureFlagGate = ({ flag, children }: FeatureFlagGateProps): ReactElement | null =>
  featureFlagsService.has(flag) ? <>{children}</> : null;

export default FeatureFlagGate;

export interface PostHogFeatureFlagProps {
  flag: PostHogFeatureFlag;
  children?: ReactNode;
}
export const PostHogFeatureFlagGate = ({
  flag,
  children,
}: PostHogFeatureFlagProps): ReactElement | null => {
  const enabled = usePostHogFeatureFlag(flag);
  return enabled ? <>{children}</> : null;
};
